import { z } from 'zod';

// ====================================================================
// Skema untuk Validasi Form Pembaruan Pengguna
// ====================================================================

/**
 * Skema Zod untuk memvalidasi data dari formulir pembaruan pengguna.
 * Didasarkan pada body request PUT /v4/user/:user_id.
 * Skema ini akan digunakan oleh react-hook-form untuk validasi di sisi klien.
 */
export const UpdateUserV4Schema = z.object({
    /**
     * Nama lengkap pengguna.
     * Wajib diisi (nonempty).
     */
    name: z.string().nonempty({ message: "Name is required." }),

    /**
     * Nomor telepon pengguna.
     * Boleh null, tetapi jika diisi tidak boleh kosong.
     * Menggunakan .optional() karena field ini 'nullable' di API.
     */
    phone: z.string().optional(),

    /**
     * Alamat email pengguna.
     * Wajib diisi dan harus dalam format email yang valid.
     */
    email: z.string().nonempty({ message: "Email is required." }).email({ message: "Invalid email address." }),

    /**
     * Password baru untuk pengguna.
     * Field ini sepenuhnya opsional.
     * Jika string kosong, akan diubah menjadi `undefined` agar tidak dikirim ke API.
     * Jika diisi, harus memiliki minimal 8 karakter.
     */
    password: z.string()
        .min(8, { message: "New password must be at least 8 characters long." })
        .or(z.literal('')) // Izinkan string kosong
        .optional()
        .transform(value => {
            // Jika nilai adalah string kosong, ubah menjadi undefined.
            // Jika tidak, kembalikan nilai aslinya.
            return value === '' ? undefined : value;
        }),
});


// ====================================================================
// Tipe TypeScript yang Diekspor
// ====================================================================

/**
 * Tipe TypeScript untuk data formulir pembaruan pengguna,
 * diturunkan secara otomatis dari skema Zod.
 * Tipe ini akan digunakan di dalam komponen form untuk type safety.
 */
export type UpdateUserFormData = z.infer<typeof UpdateUserV4Schema>;